import styled, { css } from 'styled-components'

export const Container = styled.div`
  margin: 8px 0;
  position: sticky;
  left: 0;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    display: flex;
    justify-content: space-between;
  }
`

export const ButtonContainer = styled.div`
  flex: 1;
  width: 100%;
`

export const ActionsList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 8px;
`

export const IconWrapper = styled.div``

export const ButtonList = styled.div<{ $isOverflowing?: boolean }>`
  gap: 8px;
  display: flex;
  flex-direction: column;

  > * {
    flex: 1;
  }

  > ${IconWrapper} {
    flex: none;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    display: flex;
    gap: 16px;
    flex-direction: row;
    ${({ $isOverflowing }) =>
      $isOverflowing &&
      css`
        flex-direction: column;
        gap: 8px;
      `}
  }
`
